import { graphql } from "../gql";

export const getDashboardSummaryQueryDoc = graphql(`
  query getDashboardSummary($input: DashboardSummaryInput!) {
    dashboardSummary(input: $input) {
      allowedAmount
      billedAmount
      claims
      determinedSaving
      determinedSavingPerLife
      discrepantAmount
      lives
      providers
    }
  }
`);
